import { currentLang, formatMediumDate, formatShortDate, formatYmd } from '@utils/dateUtils';

/** A day as the section writes it: "Nov 1" in the site's current year, "Nov 1, 2027" in any other. */
export function maintenanceDay(at: string, tz: string, today: string): string {
  const day = formatYmd(at, tz);
  const lang = currentLang();
  return day.slice(0, 4) === today.slice(0, 4) ? formatShortDate(day, lang, tz) : formatMediumDate(day, lang, tz);
}
